import dayjs from 'dayjs'
import { MuiTimerTimeClockInput } from './styledComponents'

export default function TimeSelectionInput({ timeInMilliseconds, setTimerSettings }) {
  const timerSeconds = timeInMilliseconds / 1000

  const seconds = Math.floor(timerSeconds % 60)
  const minutes = Math.floor((timerSeconds / 60) % 60)

  // function changeMinutes(e) {
  //   setMainDuration((prev) => ({ ...prev, minutes: e.target.value }))
  //   setTimerSettings((prev) => ({
  //     ...prev,
  //     duration: Number(e.target.value) * 60 * 1000 + Number(prev.seconds) * 1000,
  //   }))
  // }
  // function changeSeconds(e) {
  //   setMainDuration((prev) => ({ ...prev, seconds: e.target.value }))
  //   setTimerSettings((prev) => ({
  //     ...prev,
  //     duration: Number(prev.minutes) * 60 * 1000 + Number(e.target.value) * 1000,
  //   }))
  // }

  function changeDuration(timeMomentValue) {
    var minutes = timeMomentValue.format('mm')
    var seconds = timeMomentValue.format('ss')

    if (!timeMomentValue.isValid()) {
      setTimerSettings((prev) => ({
        ...prev,
        duration: prev?.duration,
      }))
    }

    if (isNaN(minutes)) {
      timeMomentValue = timeMomentValue.add(1, 'minute')
    }

    if (isNaN(seconds)) {
      timeMomentValue = timeMomentValue.add(1, 'second')
    }

    console.log({ minutes, seconds })

    setTimerSettings((prev) => ({
      ...prev,
      duration: Number(minutes) * 60 * 1000 + Number(seconds) * 1000,
    }))
  }

  return (
    <div
      style={{
        // display: 'grid',
        justifyContent: 'center',
        alignItems: 'center',
        // gridTemplateColumns: 'repeat(3, 1fr)',
        maxWidth: '300px',
        margin: '0 auto',
      }}
    >
      <MuiTimerTimeClockInput
        label="Format with seconds"
        value={dayjs(
          `2022-04-17T15:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`,
        )}
        isTimeInvalid={isNaN(timeInMilliseconds) || timeInMilliseconds <= 0}
        onChange={changeDuration}
        // defaultValue={dayjs('2022-04-17T15:30')}
        format="mm:ss"
      />
      {/* <TimerTimeClockInput
        value={String(minutes).padStart(2, '0')}
        onChange={changeMinutes}
        type="number"
      />
      <div style={{ textAlign: 'center' }}>:</div>
      <TimerTimeClockInput
        value={String(seconds).padStart(2, '0')}
        onChange={changeSeconds}
        type="number"
      /> */}
    </div>
  )
}
